/**
 * Vuex mutations for the department module.
 *
 * @module store/modules/department/mutations
 */
import { MutationTree } from "vuex/types";
import { DepartmentState } from "./types";
import Vue from "vue";
import _ from "lodash";

const mutations: MutationTree<DepartmentState> = {
  /**
   * Sets the complete list of departments.
   *
   * @param {DepartmentState} state - Module state
   * @param {Array} payload - Array of department objects
   */
  SET_DEPARTMENTS(state, payload) {
    state.departments = payload;
  },

  /**
   * Sets the loading state for department creation.
   *
   * @param {DepartmentState} state - Module state
   * @param {boolean} isLoading - Loading flag
   */
  SET_CREATE_LOADING(state, isLoading) {
    Vue.set(state, "createLoading", isLoading);
  },

  /**
   * Deletes a department from the list by ID.
   *
   * @param {DepartmentState} state - Module state
   * @param {string} payload - Department ID to delete
   */
  DEPARTMENT_DELETE(state, payload) {
    const departments = _.cloneDeep(state.departments);
    const deleted = departments.findIndex((department) => department.id === payload);
    departments.splice(deleted, 1);
    Vue.set(state, "departments", departments);
  },

  /**
   * Adds a new department to the list.
   *
   * @param {DepartmentState} state - Module state
   * @param {Object} payload - Department object to add
   */
  DEPARTMENT_ADD(state, payload) {
    const departments = _.cloneDeep(state.departments);
    departments.push(payload);
    Vue.set(state, "departments", departments);
  },

  /**
   * Updates an existing department in the list.
   *
   * @param {DepartmentState} state - Module state
   * @param {Object} payload - Updated department object with id
   */
  DEPARTMENT_UPDATE(state, payload) {
    const departments = _.cloneDeep(state.departments);
    const updatedIndex = departments.findIndex((item) => item.id === payload.id);
    if (updatedIndex > -1) {
      departments.splice(updatedIndex, 1, payload);
      Vue.set(state, "departments", departments);
    }
  },
};

export default mutations;
